import React, { useContext, useEffect, useState } from "react";
import { Card, CardActions, CardContent, Typography } from "@mui/material";
import ButtonContained from "../../components/StyledComponents/ButtonContained";
import ButtonOutlined from "../../components/StyledComponents/ButtonOutlined";

import { BusyIndicator } from '@ui5/webcomponents-react';


import { useSnackbar } from "notistack";
import httpRequest from "../../httpRequest";
import userContext from "../../context/user-context";
import AppLayout from "../../components/AppLayout/AppLayout";
import { useStyles } from "./styles";



const GeneralScan = () => {
  const classes = useStyles();
  const userCtx = useContext(userContext);
  const [userName, setUserName] = useState("");
  const [activeStep, setActiveStep] = useState(1);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [selectedFormat, setSelectedFormat] = useState(null);
  const [convertedDocument, setConvertedDocument] = useState(null);
    const [isConverting, setIsConverting] = useState(false); // State to track conversion process
	  const [fileContent, setFileContent] = useState(""); // State to hold content of uploaded file


  const { enqueueSnackbar } = useSnackbar();

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
	setIsConverting(false);
  };

 const handleFileUpload = (file) => {
    setUploadedFile(file);
    const reader = new FileReader();
    reader.onload = () => {
      setFileContent(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const renderFileContent = () => {
    if (!uploadedFile) {
      return null;
    }

    if (uploadedFile.type.includes("image")) {
      return <img src={fileContent} alt="Uploaded file" />;
    } else if (uploadedFile.type === "application/pdf") {
      return <iframe src={fileContent} title="Uploaded PDF" width="50%" height="600px" />;
    } else {
      return <p>Unsupported file format</p>;
    }
  };

const convertPdfToImage = async (uploadedFile) => {
  const formData = new FormData();
  formData.append('uploadedFile', uploadedFile);

  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/convert/pdf_to_image`, {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      throw new Error('Failed to convert PDF to image');
    }

    const imageData = await response.blob();
    return imageData;
  } catch (error) {
    console.error('Error converting PDF to image:', error.message);
    throw error;
  }
};




const handleFormatSelect = async (format) => {
  setSelectedFormat(format);
  setIsConverting(true);
  let documentToConvert = uploadedFile;

  console.log("Starting conversion for format:", format); // Log start of process

  if (uploadedFile.type === "application/pdf" && format !== "Docx") {
    try {
      documentToConvert = await convertPdfToImage(uploadedFile);
      console.log("PDF converted to image successfully");
    } catch (error) {
      console.error("Error converting PDF to image:", error.message);
      enqueueSnackbar("Failed to convert PDF to image", { variant: "error" });
      setIsConverting(false);
      return;
    }
  }

  if (uploadedFile.type === "application/pdf" && format === "Docx") {
    try {
      const pdfBase64 = await getFileAsBase64(uploadedFile);
      console.log("Sending PDF to backend for DOCX conversion");
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/convert/pdf-to-docx`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ pdfBase64 }),
      });
      if (response.ok) {
        const docxBlob = await response.blob();
        const docxUrl = URL.createObjectURL(docxBlob);
        setConvertedDocument(docxUrl);
        enqueueSnackbar(`Conversion to ${format.toUpperCase()} finished`, { variant: "info" });
        setActiveStep((prevStep) => prevStep + 1);
        console.log("DOCX conversion successful");
      } else {
        throw new Error("Failed to convert PDF to DOCX");
      }
    } catch (error) {
      console.error("DOCX conversion error:", error.message);
      enqueueSnackbar("Error initiating conversion", { variant: "error" });
      setIsConverting(false);
    }
  } else {
    // Handle image-based conversions (JSON, HTML, XML)
    const prompt = `Extract the text from the provided image using OCR and convert it into valid ${format.toUpperCase()} format. Return only the raw ${format.toUpperCase()} code without any explanations, error messages, or additional text. If you cannot process the image, return an empty ${format.toUpperCase()} structure (e.g., "{}" for JSON, "<html></html>" for HTML, "<root></root>" for XML).`;

    try {
      const reader = new FileReader();
      reader.readAsDataURL(documentToConvert);
      reader.onload = async () => {
        const base64Image = reader.result.split(",")[1];
        console.log("Base64 image prepared for API call");

        if (!base64Image) {
          console.error("Error: Base64 image data is undefined");
          enqueueSnackbar("Error preparing image for conversion", { variant: "error" });
          setIsConverting(false);
          return;
        }

        const response = await fetch("https://api.openai.com/v1/chat/completions", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer sk-proj-j3YasCgXEuYlEGcSq3tZT3BlbkFJ7hEq6w26R5SQo5QvbVAD",
          },
          body: JSON.stringify({
            model: "gpt-4o",
            messages: [
              {
                role: "user",
                content: [
                  { type: "text", text: prompt },
                  {
                    type: "image_url",
                    image_url: {
                      url: `data:image/jpeg;base64,${base64Image}`,
                      detail: "high", // Explicitly set detail level
                    },
                  },
                ],
              },
            ],
          }),
        });

        if (response.ok) {
          const data = await response.json();
          console.log("API response received:", data);

          if (data.choices && data.choices.length > 0) {
            let convertedContent = data.choices[0].message.content;

            // Filter out unwanted GPT responses
            if (convertedContent.includes("sorry") || convertedContent.includes("cannot assist")) {
              console.warn("GPT returned an error message, using empty format instead");
              convertedContent = format.toLowerCase() === "json"
                ? "{}"
                : format.toLowerCase() === "html"
                ? "<html></html>"
                : "<root></root>";
            }

            setConvertedDocument(convertedContent);
            enqueueSnackbar(`Conversion to ${format.toUpperCase()} finished`, { variant: "info" });
            setActiveStep((prevStep) => prevStep + 1);
            console.log("Converted content set:", convertedContent);
          } else {
            console.error("Error: No choices in API response");
            enqueueSnackbar("Error processing conversion", { variant: "error" });
          }
        } else {
          const responseBody = await response.text();
          console.error(`API error ${response.status}: ${responseBody}`);
          enqueueSnackbar("Error initiating conversion", { variant: "error" });
        }
      };
      reader.onerror = () => {
        console.error("Error reading file:", reader.error);
        enqueueSnackbar("Error reading file", { variant: "error" });
        setIsConverting(false);
      };
    } catch (error) {
      console.error("Conversion error:", error.message);
      enqueueSnackbar("Error initiating conversion", { variant: "error" });
      setIsConverting(false);
    }
  }
};

 const getFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

 const downloadConvertedDocument = () => {
  let content = convertedDocument;

  // Function to strip content before the first { and after the last } in JSON
  const stripJsonContent = (jsonString) => {
    const firstIndex = jsonString.indexOf('{');
    const lastIndex = jsonString.lastIndexOf('}');
    if (firstIndex !== -1 && lastIndex !== -1) {
      return jsonString.substring(firstIndex, lastIndex + 1);
    }
    return jsonString;
  };

  // Function to strip content before the first < and after the last > in HTML or XML
  const stripTagContent = (tagString) => {
    const firstIndex = tagString.indexOf('<');
    const lastIndex = tagString.lastIndexOf('>');
    if (firstIndex !== -1 && lastIndex !== -1) {
      return tagString.substring(firstIndex, lastIndex + 1);
    }
    return tagString;
  };

  if (selectedFormat.toLowerCase() === 'json') {
    content = stripJsonContent(content);
  } else if (selectedFormat.toLowerCase() === 'html' || selectedFormat.toLowerCase() === 'xml') {
    content = stripTagContent(content);
  }

  const fileName = `converted_document.${selectedFormat.toLowerCase()}`;
  const blob = new Blob([content], { type: "text/plain" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  
   const downloadConvertedDocx = () => {
    const fileName = `converted_document.${selectedFormat.toLowerCase()}`;
    const link = document.createElement("a");
    link.href = convertedDocument;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const renderStepContent = () => {
    switch (activeStep) {
      case 1:
        return (
          <>
           <div style={{
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}}>
  <Card style={{
    width: '40%'
  }}>
    <CardContent>
      <Typography variant="h5" gutterBottom style={{ fontFamily: 'SapFiori72' }}>
        Upload Document
      </Typography>
      <input type="file" onChange={(e) => handleFileUpload(e.target.files[0])} />
    </CardContent>
    <CardActions style={{ display: 'flex', justifyContent: 'center' }}>
       {uploadedFile ? (
      <ButtonContained onClick={handleNext}>
        Next
      </ButtonContained>
    ) : (
      <ButtonContained disabled>
        Next
      </ButtonContained>
    )}
    </CardActions>
  </Card>
</div>

          </>
        );
      case 2:
        return (
          <>
 <div style={{
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}}>
  <Card style={{
    width: '40%'
  }}>              <CardContent>
  <Typography variant="h5" gutterBottom style={{ fontFamily: 'SapFiori72' }}>
    Choose Format
  </Typography>
  {uploadedFile && uploadedFile.type.includes("image") ? (
    <ButtonOutlined disabled style={{ marginRight: '10px' }} onClick={() => handleFormatSelect("Docx")}>
      DOCX
    </ButtonOutlined>
  ) : (
    <ButtonOutlined style={{ marginRight: '10px' }} onClick={() => handleFormatSelect("Docx")}>
      DOCX
    </ButtonOutlined>
  )}

  <ButtonOutlined style={{ marginRight: '10px' }} onClick={() => handleFormatSelect("JSON")}>
    JSON
  </ButtonOutlined>
  <ButtonOutlined style={{ marginRight: '10px' }} onClick={() => handleFormatSelect("HTML")}>
    HTML
  </ButtonOutlined>
  <ButtonOutlined onClick={() => handleFormatSelect("XML")}>
    XML
  </ButtonOutlined>
</CardContent>
{isConverting && <BusyIndicator active />}

                  <CardActions style={{ display: 'flex', justifyContent: 'center' }}>

                <ButtonContained variant="contained" onClick={handleBack}>
                  Back
                </ButtonContained>
              </CardActions>
            </Card>
			</div>
          </>
        );
      case 3:
        return (
          <>
            <div style={{
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}}>
  <Card style={{
    width: '40%'
  }}>
              <CardContent>
                <Typography variant="h5" gutterBottom style={{ fontFamily: 'SapFiori72' }}>
                  Download Converted Document
                </Typography>
                <Typography variant="body1" gutterBottom>
                  Your document has been converted. Click the button below to download.
                </Typography>
              </CardContent>
            <CardActions style={{ display: 'flex', justifyContent: 'center' }}>
               {uploadedFile.type === "application/pdf" && selectedFormat === "Docx" ? (
    <ButtonContained
      variant="contained"
      color="primary"
      onClick={() => {downloadConvertedDocx();}}
    >
      Download as DOCX
    </ButtonContained>
  ) : (
    <ButtonContained
      variant="contained"
      color="primary"
      onClick={() => {downloadConvertedDocument();}}
    >
      Download
    </ButtonContained>
  )}


                <ButtonOutlined onClick={handleBack}>
                  Back
                </ButtonOutlined>
              </CardActions>
            </Card>
			</div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <AppLayout userName={userName}>
      <div className={classes.content}>
        {renderStepContent()}
      </div>
	  
           <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '20px' }}>
        {renderFileContent()}
      </div>
      
    </AppLayout>
  );
};

export default GeneralScan;
